<template>
  <page-layout>
    <el-card>
      <div slot="header">
        <span>账号信息管理</span>
      </div>
      <p>账号信息管理页面内容</p>
    </el-card>
  </page-layout>
</template>

<script>
export default {
  name: 'UserAccountList'
}
</script>



